import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import _ from 'lodash';
import Api from 'constants/Api';
import {getApiService} from '../redux/services/HttpService';
import Router, {useRouter} from 'next/router';
import Cookies from 'js-cookie';

import {useThemeSwitcher} from 'react-css-theme-switcher';

import * as AuthActions from '../redux/actions/AuthActions';
import * as UserActions from '../redux/actions/UserActions';
import * as ThemeActions from '../redux/actions/ThemeActions';
import * as WalletActions from '../redux/actions/WalletActions';

import Loading from './common/Loading';
import {message} from 'antd';

export const retrieveCryptoAndWallet = async (dispatch) => {
    try {
        let currencies_info = await getApiService(
            Api.CRYPTO_WALLETS_V1,
            false);

        if (currencies_info.success === false) {
            message.error({
                content: 'با عرض پوزش؛ خطایی در درخواست دریافت ارزها بوجود آمده است، لطفا دقایقی دیگر دوباره امتحان نمایید.',
                className: 'ant-message-bg-error'
            });
            console.log('There is an error on retrieve active currencies')
        } else {
            let {data: currencies} = currencies_info
            currencies = currencies.results

            let accounting_balance = await getApiService(Api.ACCOUNTING_BALANCE);
            if (accounting_balance.success === false) {
                message.error({
                    content: 'با عرض پوزش؛ خطایی در درخواست دریافت موجودی کیف‌پول ریالی بوجود آمده است، لطفا دقایقی دیگر دوباره امتحان نمایید.',
                    className: 'ant-message-bg-error'
                });
                console.log('There is an error on retrieve active currencies')
            } else {
                let {data: fiat_balance} = accounting_balance
                fiat_balance = fiat_balance.results

                dispatch(WalletActions.handleSetWalletData({
                    cryptoWallets: currencies,
                    fiatBalance: {
                        balance: fiat_balance.balance,
                        blockedBalance: fiat_balance.blocked_balance,
                        unConfirmedBalance: fiat_balance.not_confirm_balance
                    }
                }))
            }
        }
    } catch (e) {
        console.log(e)
    }
}

const RequirementSystem = ({children, ...props}) => {
    const {switcher: themeSwitcher, themes, currentTheme, status: themeStatus} = useThemeSwitcher();
    const [authReady, setAuthReady] = useState(false)
    const [loadingPage, setLoadingPage] = useState(true)
    const [loadingLayout, setLoadingLayout] = useState(true)

    const VIEW_PORTS = {
        DESKTOP: 1,
        TABLET: 2,
        MOBILE: 3
    }
    const dispatch = useDispatch();
    const [viewPort, setViewPort] = useState(null)
    let {pathname} = useRouter()
    let {Component, pageProps, currentPath, layoutClass} = props;
    let {authOnly, guestOnly, requirementCheck, dontRedirect} = pageProps

    const Auth = useSelector((state) => state.Auth);
    const User = useSelector((state) => state.User);
    const WalletUDT = useSelector((state) => state.Wallet.udt);
    const WalletCryptos = useSelector((state) => state.Wallet.cryptoWallets);
    const ThemeState = useSelector((state) => state.Theme);

    const retrieveUserInfo = async () => {
        let pingi_auth_token = Cookies.get('pingi_auth_token');

        if (pingi_auth_token) {
            try {
                if (Auth.token !== pingi_auth_token)
                    dispatch(AuthActions.handleLoginSetToken(pingi_auth_token ?? null)).then(() => {
                        setAuthReady(true)
                    });

                if (User.info === null) {
                    let user_info = {
                        user_data: {},
                        plan_data: {}
                    }
                    const user_plan_result = await getApiService(Api.ACCOUNTING_GET_PLAN_DETAILS, false, pingi_auth_token);
                    const user_info_result = await getApiService(Api.SESSION_GET_INFO, false, pingi_auth_token);

                    if (user_plan_result.success === false) {
                        console.log('There an error on retrieve user plan details');
                    } else {
                        user_info.plan_data = user_plan_result.data.results.user_status
                    }

                    if (user_info_result.success === false) {
                        console.log('There an error on retrieve user info details');
                    } else {
                        user_info.user_data = user_info_result.data.results
                    }
                    if (!_.isEmpty(user_info.user_data))
                        dispatch(UserActions.handleSetUserData(user_info)).then(() => {
                            setAuthReady(true)
                        })
                    // else
                    //     Router.push(`/error?redirect=${pathname}`, `/error?redirect=${pathname}`)
                }
            } catch (e) {

            }
        } else {
            setAuthReady(true)
        }
    }

    const checkUserAuthentication = async (
        authOnly = false, guestOnly = false,
        dontRedirect = false) => {
        try {
            let pingi_auth_token = Auth.token
            let redirect = '';

            if (authOnly && !pingi_auth_token) {
                redirect = '/login/?redirect=' + props.router.state.asPath;
            } else if (guestOnly && pingi_auth_token) {
                redirect = '/';
            } else if (pingi_auth_token && !_.isNull(User.error) && User.error.code === 401) {
                redirect = '/logout';
            }

            // if (guestOnly && pingi_auth_token) {
            //     redirect = '/';
            // } else if (pingi_auth_token && !_.isNull(User.error) && User.error.code === 401) {
            //     redirect = '/logout';
            // }

            if (User.info !== null) {
                let queryString = '';
                let {is_mobile_verified, is_email_verified} = User.info;
                if (!is_mobile_verified && !is_email_verified)
                    if (queryString)
                        redirect = `/verify?${queryString}`
                    else
                        redirect = '/verify';
            }

            /**
             * Check if redirect location specified
             */
            if (redirect && !dontRedirect) {
                await Router.push(redirect);
            } else {
                setLoadingPage(false)
            }
        } catch (e) {

        }
    }

    const updateSize = () => {
        appHeight();

        if (window.innerWidth < 767) {
            setViewPort(VIEW_PORTS.MOBILE)
        } else if (window.innerWidth < 1200) {
            setViewPort(VIEW_PORTS.TABLET)
        } else {
            setViewPort(VIEW_PORTS.DESKTOP)
        }
    };

    const appHeight = () => {
        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    const initiatePage = () => {
        let is_app_initiate = Cookies.get('is_app_initiate') ?? ''
        if (!is_app_initiate) {
            Cookies.set('is_app_initiate', true, {
                domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
                path: '/',
                sameSite: 'lax'
            });
        }
    }

    useEffect(() => {
        switch (viewPort) {
            case VIEW_PORTS.DESKTOP:
                dispatch(ThemeActions.handleChangeDeviceWidth({
                    mobileView: false,
                    tabletView: false,
                    desktopView: true
                }))
                break;
            case VIEW_PORTS.TABLET:
                dispatch(ThemeActions.handleChangeDeviceWidth({
                    mobileView: true,
                    tabletView: true,
                    desktopView: false
                }))
                break;
            case VIEW_PORTS.MOBILE:
                dispatch(ThemeActions.handleChangeDeviceWidth({
                    mobileView: true,
                    tabletView: false,
                    desktopView: false
                }))
                break;
        }
    }, [viewPort])

    useEffect(() => {
        let theme_cookie = Cookies.get('theme') ?? ''
        if (!_.isNull(ThemeState.theme) && theme_cookie !== ThemeState.theme) {
            Cookies.set('theme', ThemeState.theme, {
                domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
                path: '/',
                sameSite: 'lax',
                expires: 365
            });
        } else if (theme_cookie === '') {
            Cookies.set('theme', 'dark', {
                domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
                path: '/',
                sameSite: 'lax',
                expires: 365
            });
        }

        if (ThemeState.theme !== currentTheme && themeStatus === 'loaded') {
            themeSwitcher({theme: ThemeState.theme === 'light' ? themes.light : themes.dark});
        }
    }, [ThemeState.theme, currentTheme, themeStatus])


    useEffect(() => {
        if (ThemeState.layoutSet) {
            setLoadingLayout(false)
        }
    }, [ThemeState.layoutSet])


    /**
     * Retrieve user info by changes on props
     */
    useEffect(() => {
        if (requirementCheck !== false)
            retrieveUserInfo().then()
        else
            setLoadingPage(false)
    }, [pathname, Auth, User, requirementCheck, dontRedirect])

    /**
     * Update on crypto wallets
     */
    useEffect(() => {
        if (authReady)
            if ((_.isNull(WalletUDT) || _.isEmpty(WalletCryptos)) && !_.isNull(Auth.token)) {
                retrieveCryptoAndWallet(dispatch).then()
            }
    }, [pathname, Auth, authReady, WalletUDT, WalletCryptos])

    useEffect(() => {
        if (authReady && requirementCheck !== false) {
            checkUserAuthentication(authOnly, guestOnly).then()
        }
    }, [pathname, Auth, authReady, User, authOnly, guestOnly, requirementCheck, dontRedirect])

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', updateSize);
            updateSize();
            appHeight();
            initiatePage();

            try {
                let {query} = props.router.state
                if (typeof query['add_to_home'] !== "undefined") {
                    localStorage.setItem('ignoreAddToHome', true);
                }
            } catch (e) {
                // Nothing
            }
        }

        let theme_cookie = Cookies.get('theme') ?? ''
        if (ThemeState.theme == null && theme_cookie) {
            dispatch(ThemeActions.handleChangeTheme({
                theme: theme_cookie
            }))
        }

        return () => {
            window.removeEventListener('resize', updateSize);
        }
    }, [])

    return ((loadingPage && themeStatus !== 'loaded') || loadingPage || loadingLayout) ? <Loading/> : children
}

export default RequirementSystem;
